export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: '14px',
  height: '100%',
  minHeight: '480px',
  padding: '32px',
  borderRadius: '10px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const titleStyles = {
  color: ({ palette }) => palette.text.primary,
};

export const subtitleStyles = {
  maxWidth: '380px',
  color: ({ palette }) => palette.text.secondary,
};

export const progressStyles = {
  width: '260px',
  height: '6px',
  borderRadius: '3px',
  marginTop: '6px',
};
